import React, { PureComponent } from "react";
import classNames from "../../utils/classnames";

export class Label extends PureComponent {
  render() {
    const { className, children, component, htmlFor, ...others } = this.props;
    const cls = classNames({
      "weui-label": true
    }, className);
    const Comp = component || (htmlFor ? "label" : "span");

    return (
      <Comp className={ cls } htmlFor={ htmlFor } { ...others }>{ children }</Comp>
    );
  }
}
